import { render, staticRenderFns } from "./TwitterIcon.vue?vue&type=template&id=197869b0&scoped=true"
import script from "./TwitterIcon.vue?vue&type=script&lang=js"
export * from "./TwitterIcon.vue?vue&type=script&lang=js"
import style0 from "./TwitterIcon.vue?vue&type=style&index=0&id=197869b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197869b0",
  null
  
)

export default component.exports